<div class="evs-fav-teacher-modal" #modal>
  <div class="evs_modal_bg" (click)="closeModal()" #modalBg></div>
  <div class="evs_modal_container" #modalContainer>
    <ng-content></ng-content>
  </div>
</div>
